module.exports = __webpack_public_path__ + "static/media/asili-del-popolo.7e050f0e.svg";